// extracted by mini-css-extract-plugin
export var infoItem = "_oj-2";
export var title = "_oj-0";
export var value = "_oj-1";